import { Button } from "antd";

interface IBVCancelButton {
	setCancelVisible: (visible: boolean) => void;
	timeRemaining: string;
}

const BVCancelButton: React.FC<IBVCancelButton> = ({
	setCancelVisible,
	timeRemaining
}) => {
	return (
		<Button
			className="cancel-button"
			type="primary"
			size={"large"}
			onClick={() => setCancelVisible(true)}
			disabled={timeRemaining === "TIME OUT"}
			style={{
				color: "#fff",
				borderColor: "#999999",
				backgroundColor: timeRemaining === "TIME OUT" 
                ? "#d9d9d9" : "#8B0000"
			}}
		>
			{"Cancel"}
		</Button>
	);
};

export default BVCancelButton;